import React from 'react';

import Typography from 'components/typography/typography';

const DocumentInstructions: React.FC = () => {
  return (
    <div className="w-full flex flex-col">
      <Typography as="p" variant="body-medium" className="text-gray600">
        Om als freelancer te kunnen werken in de kinderopvang via Tadaah hebben
        wij verschillende documenten van je nodig. In de komende stappen krijg
        je uitgelegd welke documenten we nodig hebben en waarvoor. Per stap
        wordt precies uitgelegd welk document je kan uploaden en aan welke eisen
        dit specifieke document moet voldoen.
        <br />
        <br />
        {`Voor alle documenten geldt dat je bij het uploaden van de documenten
        rekening moet houden met o.a. de bestandsstructuur (bijvoorbeeld pdf of
        png), de grootte, kwaliteit van het bestand en de herkomst van het
        document. Volg voor elk document goed de betreffende instructies.`}
      </Typography>
    </div>
  );
};

export default DocumentInstructions;
